import React from 'react';
import styles from './homeEmailCapture.css';

import EmailCaptureForm from '../../../components/EmailCapture/EmailCaptureForm';
import EmailCloudEyes from '../../../assets/svg/EmailCloudEyes';

const HomeEmailCapture = () => {
  return (
    <div className={styles.emailCaptureWrapper}>
      <div className={styles.content}>
        <div className={styles.eyesWrapper}>
          <EmailCloudEyes />
        </div>
        <EmailCaptureForm subscribeButtonClass={styles.subscribeButton} />
      </div>
    </div>
  );
};

export default HomeEmailCapture;
